/* Warm product template: scroll reveals + click-to-load video. Safe to include from several sections. */
(function () {
  if (window.__hfProduct) return;
  window.__hfProduct = true;

  // Two visible neighbours on the same background would stack both paddings into one dead band:
  // flag the lower one so CSS drops its top padding. Hidden sections (empty addons/video) are skipped,
  // and it re-runs when <main> resizes because those can appear once their apps render.
  // Same pass flags zero-height app blocks in the buy column so they stop carrying a block margin.
  function joinSections() {
    var prev = null;
    document.querySelectorAll('main > .shopify-section').forEach(function (s) {
      if (!s.offsetHeight) return;
      var sec = s.querySelector('.hf-sec');
      var bg = sec && getComputedStyle(sec).backgroundColor;
      if (sec) sec.classList.toggle('hf-sec--join', prev === bg);
      prev = sec ? bg : null;
    });
    document.querySelectorAll('.product-info > .shopify-block').forEach(function (b) {
      b.classList.toggle('hf-nil', !b.offsetHeight);
    });
  }

  // sqarp shows few options as a button grid and many as a dropdown; we want the dropdown everywhere.
  // Rebuild text-only grids with sqarp's own <details> markup so its CSS styles them. Swatch grids stay.
  function gridsToDropdowns() {
    document.querySelectorAll('.sqarp-option-grid').forEach(function (grid) {
      if (grid.querySelector('img')) return;
      var opts = grid.querySelectorAll('a.sqarp-option');
      var picked = grid.querySelector('.sqarp-option-picked') || opts[0];
      if (!picked) return;
      var d = document.createElement('details');
      d.className = 'sqarp-option-details';
      d.innerHTML = '<summary><span class="sqarp-option sqarp-option-span"><span></span><i class="fa-solid fa-angle-down"></i></span></summary><div class="sqarp-option-details-drop"></div>';
      d.querySelector('summary span span').textContent = picked.textContent.trim();
      var drop = d.lastChild;
      opts.forEach(function (a) {
        if (a === picked) return;
        a.className = 'sqarp-option sqarp-option-span';
        a.style.gridColumn = '';
        drop.appendChild(a);
      });
      grid.replaceWith(d);
    });
  }

  function init() {
    gridsToDropdowns();
    joinSections();
    var main = document.querySelector('main');
    if (main && 'ResizeObserver' in window) new ResizeObserver(joinSections).observe(main);

    if ('IntersectionObserver' in window) {
      document.documentElement.classList.add('hf-js');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      document.querySelectorAll('.hf-rv').forEach(function (el) { io.observe(el); });
    }


    var noMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // add-to-cart: shine class + loading lock. Apps (weebe cart drawer) hijack the theme's add flow, so completion
    // is detected on the /cart/add request itself (fetch + XHR), plus the theme's own events as a bonus.
    document.querySelectorAll('form[is="product-form"]').forEach(function (form) {
      var formId = form.getAttribute('id'); // form.id would return the hidden <input name="id">
      var buttons = function () {
        var list = [].slice.call(form.querySelectorAll('button[type="submit"]'));
        if (formId) list = list.concat([].slice.call(document.querySelectorAll('button[type="submit"][form="' + formId + '"]')));
        return list;
      };
      var busy = false, timer;
      function lock() {
        busy = true;
        buttons().forEach(function (b) { b.classList.add('hf-loading'); b.setAttribute('aria-disabled', 'true'); });
        clearTimeout(timer);
        timer = setTimeout(release, 10000); // ponytail: safety net if nothing ever reports completion
      }
      function release() {
        if (!busy) return;
        busy = false; clearTimeout(timer);
        buttons().forEach(function (b) { b.classList.remove('hf-loading'); b.removeAttribute('aria-disabled'); });
      }
      buttons().forEach(function (b) { b.classList.add('hf-atc'); });
      // delegated + capture: apps clone the button (dropping element listeners) and may stop propagation
      document.addEventListener('click', function (ev) {
        var b = ev.target.closest && ev.target.closest('button.hf-atc');
        if (!b || buttons().indexOf(b) < 0) return;
        if (busy) { ev.preventDefault(); ev.stopImmediatePropagation(); return; }
        lock();
      }, true);
      form.addEventListener('submit', function (ev) {
        if (busy && form.dataset.hfSubmitted) { ev.preventDefault(); ev.stopImmediatePropagation(); return; }
        form.dataset.hfSubmitted = '1';
        if (!busy) lock();
      }, true);
      form.addEventListener('variant:add', release);
      form.addEventListener('cart:error', release);
      window.__hfAtcRelease = (window.__hfAtcRelease || []).concat(function () { delete form.dataset.hfSubmitted; release(); });
    });
    var releaseAll = function () { (window.__hfAtcRelease || []).forEach(function (f) { f(); }); };
    var isAdd = function (u) { return /\/cart\/add(\.js)?(\?|$)/.test(String(u)); };
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var p = origFetch.apply(this, arguments);
      if (isAdd(typeof input === 'string' ? input : input && input.url)) p.then(function () { setTimeout(releaseAll, 150); }, releaseAll);
      return p;
    };
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      if (isAdd(url)) this.addEventListener('loadend', function () { setTimeout(releaseAll, 150); });
      return origOpen.apply(this, arguments);
    };

    // smooth open/close for spec + FAQ accordions (native <details> jumps)
    if (!noMotion) document.querySelectorAll('.hf-acc details').forEach(function (d) {
      var s = d.querySelector('summary'), c = s && s.nextElementSibling;
      if (!c) return;
      s.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (d.hasAttribute('data-busy')) return;
        d.setAttribute('data-busy', '1');
        if (d.open) {
          var a = c.animate([{ height: c.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)' });
          a.onfinish = function () { d.open = false; d.removeAttribute('data-busy'); };
        } else {
          d.open = true;
          var b = c.animate([{ height: '0px', opacity: 0 }, { height: c.offsetHeight + 'px', opacity: 1 }], { duration: 340, easing: 'cubic-bezier(.22,1,.36,1)' });
          b.onfinish = function () { d.removeAttribute('data-busy'); };
        }
      });
    });

    document.addEventListener('click', function (ev) {
      // sqarp "Läs mer" links to #product-descriptions, which also exists in main-product's hidden bonus layout
      var more = ev.target.closest('a[href$="#product-descriptions"]');
      var feats = document.querySelector('.hf-feats');
      if (more && feats) { ev.preventDefault(); feats.scrollIntoView({ behavior: 'smooth' }); return; }

      var btn = ev.target.closest('.hf-play');
      if (!btn) return;
      var box = btn.closest('.hf-video');
      var tpl = box && box.querySelector('template');
      if (!tpl) return;
      box.appendChild(tpl.content.cloneNode(true));
      btn.remove();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
